import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { SaveAndGetNextQuestionRPC } from "./saveAndGetNextQuestionRPC";

export class SaveAndGetNextQuestionRPCClientImpl extends SaveAndGetNextQuestionRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: SaveAndGetNextQuestionRPC.Request): Promise<LeoRPCResult<SaveAndGetNextQuestionRPC.Response, SaveAndGetNextQuestionRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-respondent/SaveAndGetNextQuestion",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      SaveAndGetNextQuestionRPC.ResponseDTO,
      SaveAndGetNextQuestionRPC.Errors.ErrorsDTO,
      SaveAndGetNextQuestionRPC.Response,
      SaveAndGetNextQuestionRPC.Errors.Errors
    >(
      response,
      "survey-respondent/SaveAndGetNextQuestion",
      SaveAndGetNextQuestionRPC.Response.fromDTO,
      SaveAndGetNextQuestionRPC.Errors.fromDTO
    );
  }
}
